import React from "react";    
import ActivationEmailForm from "../../components/Auth/ActivationEmailForm";

const ActivationEmail = () => {
  return (
    <>
      <ActivationEmailForm />
    </>
  );
};

export default ActivationEmail;
